import { Patient as PatientResource } from "@curai/js-fhir-tools";
import type { ChatUser } from "../types/chatMessageTypes";

// Helper function to get display name for a user
export const getUserDisplayName = (user: ChatUser | undefined): string => {
  if (!user) return "Unknown User";

  // For professionals, use displayNameInternal
  if (user.professional?.displayNameInternal) {
    return user.professional.displayNameInternal;
  }

  // For patients with FHIR data
  if (user.patients?.length && user.patients[0].fhir) {
    try {
      const patientResource = new PatientResource(user.patients[0].fhir);
      // Use toString() instead of displayName() if it's a getter
      return (
        patientResource.displayName?.toString() || patientResource.toString()
      );
    } catch (error) {
      console.warn("Error parsing patient resource:", error);
    }
  }

  // Fallback to name or email
  return user.name || user.email || "Unknown User";
};

// Helper function to get initials for a user
export const getUserInitials = (user: ChatUser | undefined): string => {
  if (!user) return "?";

  const displayName = getUserDisplayName(user);

  return displayName
    .split(" ")
    .map((part) => part[0])
    .join("")
    .toUpperCase()
    .substring(0, 2);
};
